var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { InputAdornment } from '../input';
import { styled } from '../styled';
import { TextField } from '../text-field';
var colorTextFieldComponentName = 'QuantumColorTextField';
var Root = styled(TextField, { name: colorTextFieldComponentName, slot: 'Root' })({});
var ColorPicker = styled('input', { name: colorTextFieldComponentName, slot: 'ColorPicker' })(function (_a) {
    var theme = _a.theme;
    return ({
        height: 30,
        width: 25,
        margin: 0,
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
        color: 'transparent',
        '&:focus': __assign({ outline: 'none' }, theme.mixins.focusRing()),
    });
});
export var ColorTextField = React.forwardRef(function (props, ref) {
    var inputAdornmentProps = props.inputAdornmentProps, rootProps = __rest(props, ["inputAdornmentProps"]);
    return (React.createElement(Root, __assign({ ref: ref }, rootProps, { InputProps: {
            startAdornment: (React.createElement(InputAdornment, __assign({ position: "start" }, inputAdornmentProps),
                React.createElement(ColorPicker, { id: props.id ? "".concat(props.id, "-color-input") : undefined, name: props.name, type: "color", disabled: props.disabled || props.readOnly, value: props.value || props.defaultValue || props.placeholder, onChange: props.onChange }))),
        } })));
});
